/**
 * GraphQL Query
 * アップロード画面
 */

/**
 * アップロードファイル管理一覧
 */
export const GRAPH_QL_QUERY_UPLOAD_CONTROLS =
`
query {
  uploadControl {
    uuid,
    templateDisplayValue,
    account,
    filePath,
    statusCode,
    createdAt
  }
}
`

/**
 * アップロードファイル管理単体
 */
export const GRAPH_QL_QUERY_UPLOAD_CONTROL =
`
query {
  uploadControl ( ? ) {
    uuid,
    templateDisplayValue,
    account,
    filePath,
    statusCode,
    createdAt
  }
}
`

/**
 * アップロードテンプレ
 */
export const GRAPH_QL_QUERY_UPLOAD_TEMPLATE =
`
query {
  uploadTemplate {
    id,
    displayValue,
    permissionConfigRefKey
  }
}
`
